import React from "react";
import AutoCompleteItem from "../../forms/AutoCompleteItem";
import RadioButtonItem from "../../forms/RadioButtonItem";
import PhoneNumberItem from "../../forms/PhoneNumberItem";
import { InputItem, DatePickerItem } from "../../forms/FormItems";
import { CrmUsersSelect } from "../../forms/AutoCompleteFormItem";

const getItems = (entity, scopePrefix) => {
  let items = [];

  switch (entity) {
    case "leads":
      items = [
        {
          name: "surename",
          required: true,
          comp: <InputItem required={true} name="surename" category="lead" />,
        },
        {
          name: "first_name",
          required: true,
          comp: <InputItem required={true} name="first_name" category="lead" />,
        },
        {
          name: "birthday",
          comp: (
            <DatePickerItem
              name="birthday"
              category="lead"
              // disabledDate={disabledToDate}
              format={"L"}
            />
          ),
        },
        {
          name: "gender_id",
          comp: (
            <RadioButtonItem
              name="gender_id"
              required={true}
              category="lead"
              genders={true}
              translated={true}
            />
          ),
        },

        {
          name: "lead_owner_id",
          comp: (
            <CrmUsersSelect
              name="lead_owner_id"
              category="lead"
              // getUser={branch_id !== null}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },

        {
          name: "assigned_to_id",
          comp: (
            <CrmUsersSelect
              name="assigned_to_id"
              category="lead"
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
        {
          name: "address.city",
          required: true,
          comp: (
            <AutoCompleteItem name="address.city" category="lead" city={true} />
          ),
        },
        {
          name: "address.street",
          required: true,
          comp: <InputItem name="address.street" category="lead" />,
        },
        {
          name: "address.house_number",
          required: true,
          comp: <InputItem name="address.house_number" category="lead" />,
        },
        {
          name: "address.apartment_number",
          required: true,
          comp: <InputItem name="address.apartment_number" category="lead" />,
        },
        {
          name: "address.postal_code",
          required: true,
          comp: <InputItem name="address.postal_code" category="lead" />,
        },
        {
          name: "contact_info.mailbox_number",
          required: true,
          comp: (
            <InputItem name="contact_info.mailbox_number" category="lead" />
          ),
        },
        {
          name: "contact_info.mobile_number",
          // required: true,
          comp: (
            <PhoneNumberItem
              name="contact_info.mobile_number"
              category="lead"
            />
          ),
        },
        {
          name: "contact_info.phone_number",
          // required: true,
          comp: (
            <PhoneNumberItem name="contact_info.phone_number" category="lead" />
          ),
        },
        {
          name: "contact_info.fax_number",
          comp: (
            <PhoneNumberItem name="contact_info.fax_number" category="lead" />
          ),
        },
        {
          name: "contact_info.email",
          comp: (
            <InputItem name="contact_info.email" category="lead" email={true} />
          ),
        },
        {
          name: "contact_info.address.agree_to_receive_email",
          required: true,
          comp: (
            <RadioButtonItem
              name="contact_info.agree_to_receive_email"
              category="lead"
              trueFalse={true}
            />
          ),
        },
      ];
      break;

    case "opportunities":
      items = [
        {
          name: "surename",
          required: true,
          comp: (
            <InputItem required={true} name="surename" category="opportunity" />
          ),
        },
        {
          name: "first_name",
          required: true,
          comp: (
            <InputItem
              required={true}
              name="first_name"
              category="opportunity"
            />
          ),
        },
        {
          name: "birthday",
          comp: (
            <DatePickerItem
              name="birthday"
              category="opportunity"
              // disabledDate={disabledToDate}
              format={"L"}
            />
          ),
        },
        {
          name: "gender_id",
          comp: (
            <RadioButtonItem
              name="gender_id"
              required={true}
              category="opportunity"
              genders={true}
              translated={true}
            />
          ),
        },

        {
          name: "opportunity_owner_id",
          comp: (
            <CrmUsersSelect
              name="opportunity_owner_id"
              category="opportunity"
              // getUser={branch_id !== null}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },

        {
          name: "assigned_to_id",
          comp: (
            <CrmUsersSelect
              name="assigned_to_id"
              category="opportunity"
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
        {
          name: "address.city",
          required: true,
          comp: (
            <AutoCompleteItem
              name="address.city"
              category="opportunity"
              city={true}
            />
          ),
        },
        {
          name: "address.street",
          required: true,
          comp: <InputItem name="address.street" category="opportunity" />,
        },
        {
          name: "address.house_number",
          required: true,
          comp: (
            <InputItem name="address.house_number" category="opportunity" />
          ),
        },
        {
          name: "address.apartment_number",
          required: true,
          comp: (
            <InputItem name="address.apartment_number" category="opportunity" />
          ),
        },
        {
          name: "address.postal_code",
          required: true,
          comp: <InputItem name="address.postal_code" category="opportunity" />,
        },
        {
          name: "contact_info.mailbox_number",
          required: true,
          comp: (
            <InputItem
              name="contact_info.mailbox_number"
              category="opportunity"
            />
          ),
        },
        {
          name: "contact_info.mobile_number",
          // required: true,
          comp: (
            <PhoneNumberItem
              name="contact_info.mobile_number"
              category="opportunity"
            />
          ),
        },
        {
          name: "contact_info.phone_number",
          // required: true,
          comp: (
            <PhoneNumberItem
              name="contact_info.phone_number"
              category="opportunity"
            />
          ),
        },
        {
          name: "contact_info.fax_number",
          comp: (
            <PhoneNumberItem
              name="contact_info.fax_number"
              category="opportunity"
            />
          ),
        },
        {
          name: "contact_info.email",
          comp: (
            <InputItem
              name="contact_info.email"
              category="opportunity"
              email={true}
            />
          ),
        },
        {
          name: "contact_info.address.agree_to_receive_email",
          required: true,
          comp: (
            <RadioButtonItem
              name="contact_info.agree_to_receive_email"
              category="opportunity"
              trueFalse={true}
            />
          ),
        },
      ];
      break;

    case "contacts":
      items = [
        {
          name: "surename",
          required: true,
          comp: (
            <InputItem required={true} name="surename" category="contact" />
          ),
        },
        {
          name: "first_name",
          required: true,
          comp: (
            <InputItem required={true} name="first_name" category="contact" />
          ),
        },
        {
          name: "birthday",
          comp: (
            <DatePickerItem
              name="birthday"
              category="contact"
              // disabledDate={disabledToDate}
              format={"L"}
            />
          ),
        },
        {
          name: "gender_id",
          comp: (
            <RadioButtonItem
              name="gender_id"
              required={true}
              category="contact"
              genders={true}
              translated={true}
            />
          ),
        },

        {
          name: "contact_owner_id",
          comp: (
            <CrmUsersSelect
              name="contact_owner_id"
              category="contact"
              // getUser={branch_id !== null}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },

        {
          name: "assigned_to_id",
          comp: (
            <CrmUsersSelect
              name="assigned_to_id"
              category="contact"
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
        {
          name: "address.city",
          required: true,
          comp: (
            <AutoCompleteItem
              name="address.city"
              category="contact"
              city={true}
            />
          ),
        },
        {
          name: "address.street",
          required: true,
          comp: <InputItem name="address.street" category="contact" />,
        },
        {
          name: "address.house_number",
          required: true,
          comp: <InputItem name="address.house_number" category="contact" />,
        },
        {
          name: "address.apartment_number",
          required: true,
          comp: (
            <InputItem name="address.apartment_number" category="contact" />
          ),
        },
        {
          name: "address.postal_code",
          required: true,
          comp: <InputItem name="address.postal_code" category="contact" />,
        },
        {
          name: "contact_info.mailbox_number",
          required: true,
          comp: (
            <InputItem name="contact_info.mailbox_number" category="contact" />
          ),
        },
        {
          name: "contact_info.mobile_number",
          // required: true,
          comp: (
            <PhoneNumberItem
              name="contact_info.mobile_number"
              category="contact"
            />
          ),
        },
        {
          name: "contact_info.phone_number",
          // required: true,
          comp: (
            <PhoneNumberItem
              name="contact_info.phone_number"
              category="contact"
            />
          ),
        },
        {
          name: "contact_info.fax_number",
          comp: (
            <PhoneNumberItem
              name="contact_info.fax_number"
              category="contact"
            />
          ),
        },
        {
          name: "contact_info.email",
          comp: (
            <InputItem
              name="contact_info.email"
              category="contact"
              email={true}
            />
          ),
        },
        {
          name: "contact_info.address.agree_to_receive_email",
          required: true,
          comp: (
            <RadioButtonItem
              name="contact_info.agree_to_receive_email"
              category="contact"
              trueFalse={true}
            />
          ),
        },
      ];
      break;

    case "campaigns":
      items = [
        {
          name: "name",
          required: true,
          comp: <InputItem required={true} name="name" category="campaign" />,
        },
        {
          name: "active",
          required: true,
          comp: (
            <RadioButtonItem
              name="active"
              category="campaign"
              trueFalse={true}
            />
          ),
        },
        {
          name: "start_date",
          comp: (
            <DatePickerItem
              name="start_date"
              category="campaign"
              // disabledDate={disabledToDate}
              format={"L"}
            />
          ),
        },
        {
          name: "end_date",
          comp: (
            <DatePickerItem
              name="end_date"
              category="campaign"
              // disabledDate={disabledToDate}
              format={"L"}
            />
          ),
        },

        {
          name: "campaign_owner_id",
          comp: (
            <CrmUsersSelect
              name="campaign_owner_id"
              category="campaign"
              // getUser={branch_id !== null}
              extraParams={{
                scopePrefix: scopePrefix,
                filter: {},
              }}
            />
          ),
        },
      ];
      break;

    default:
      items = [];
      break;
  }
  return items;
};

export { getItems };
